document.addEventListener("click", async (e) => {
  if (!e.target.matches("#drawer-discount-apply")) return;

  const input = document.getElementById("drawer-discount-code");
  const message = document.getElementById("drawer-discount-message");

  const code = input.value.trim();

  // Reset
  message.textContent = "";
  message.className = "drawer-discount-message";

  // Empty validation
  if (!code) {
    message.textContent = "Please enter a coupon code.";
    message.classList.add("error");
    input.focus();
    return;
  }

  try {
    const response = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        discount: code
      })
    });

    const cart = await response.json();

    // Check whether the discount was actually applied
    if (
      cart.discount_codes &&
      cart.discount_codes.some(
        d => d.code.toLowerCase() === code.toLowerCase()
      )
    ) {
      message.textContent = "Coupon applied successfully.";
      message.classList.add("success");

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "discount",
        cartData: cart
      });
    } else {
      message.textContent = "Please enter a valid coupon code.";
      message.classList.add("error");
    }
    const validCodes = ["WELCOME10", "DIWALI10", "RELAX10"];
if (validCodes.includes(code.toUpperCase())) {
  message.textContent = "Coupon applied successfully.";
  message.classList.add("success");
} else {
  message.textContent = "Please enter a valid coupon code.";
  message.classList.add("error");
}


  } catch (err) {
    message.textContent = "Something went wrong. Please try again.";
    message.classList.add("error");
  }
});